import { createSelector } from 'reselect';

export const getMedicamentosPais = createSelector(state => state.MedicamentosPais, r => r);  